import clsx from "clsx";
import { motion } from "motion/react";
import type { ChildrenProps, DataAttributeProps } from "../types";
import { useModalContext } from "./context";

/** Props Interface */
interface ModalContentProps extends ChildrenProps, DataAttributeProps {
	isDraggable: boolean;
	closeOnEsc?: boolean;
	width?: string;
}

export function ModalContent({
	children,
	isDraggable,
	closeOnEsc,
	width = "500px",
	...props
}: ModalContentProps) {
	/** Context */
	const { onSubmit } = useModalContext();

	/** Motion */
	const Item = onSubmit !== undefined ? motion.form : motion.div;

	/** Render */
	return (
		<Item
			drag={isDraggable}
			dragElastic={false}
			dragMomentum={false}
			onClick={(e) => e.stopPropagation()}
			onSubmit={(e) => {
				e.stopPropagation();
				e.preventDefault();
				onSubmit?.();
			}}
			className={clsx(
				"z-20 relative bg-primary-50 dark:bg-primary-950",
				"rounded-base border border-color",
				"shadow-md",
				"max-h-[80vh]",
				"grid",
			)}
			style={{
				gridTemplateRows: "max-content 1fr max-content",
				maxWidth: "90vw",
				width,
			}}
			{...props}
		>
			{children}
		</Item>
	);
}
